export default __webpack_public_path__ + "static/media/offer2-app.bd1e5062.webm";